/**
 * Use Case: Fetch Voucherku Categories
 * Business logic for fetching the list of available Voucherku categories.
 */

import type { VoucherkuCategory } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of available Voucherku categories
 */
export const FetchVoucherkuCategoriesUseCase = async (): Promise<
  readonly VoucherkuCategory[]
> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchVoucherkuCategories();
};

